<template>
  <div id="menu-bar" class="row align-items-center">
    <div class="col-sm-4 text-center">
      <img
        alt="Logo"
        src="@/assets/media/logos/PYBLogo.png"
        class="h-80px mainlogo"
      />
    </div>
    <div class="col">
      <span
        id="home-link"
        class="landing-menu-item"
        :class="{ 'landing-isactive': isHome }"
        @click="landing"
        >Home</span
      >
    </div>
    <div class="col">
      <span
        class="landing-menu-item"
        :class="{ 'landing-isactive': isFaq }"
        @click="faq"
        >FAQ</span
      >
    </div>
    <div class="col">
      <span
        class="landing-menu-item"
        :class="{ 'landing-isactive': isContactUs }"
        @click="contactUs"
        >Contact Us</span
      >
    </div>
    <div v-if="showStartPackYuhBarrelBtn && !disableWarehouse" class="col-sm-2">
      <button
        class="btn landing-blue landing-section-2-banner rounded-pill"
        @click="startPackYuhBarrel"
      >
        Start Pack Yuh Barrel
      </button>
    </div>

    <div v-if="!isLoggedIn" class="col">
      <button
        class="btn sign-up-btn landing-button-pink rounded-pill"
        @click="signUp"
      >
        Sign Up/Sign In
      </button>
    </div>
    <div v-else class="col">
      <AuthDropdown />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { useStore } from "@/store";
import AuthDropdown from "@/components/AuthDropdown.vue";
import Appsettings from "@/config/appsettings.json";

export default Vue.extend({
  name: "UnAuthMenuBar",
  components: {
    AuthDropdown,
  },
  props: {
    showStartPackYuhBarrelBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homePage: "Landing",
      faqPage: "FAQ",
      contactUsPage: "ContactUs",
      signUpPage: "Signup",
      orderBarrel: "Order",
    };
  },
  computed: {
    isHome() {
      return this.$route.name === this.homePage;
    },
    isFaq() {
      return this.$route.name === this.faqPage;
    },
    isContactUs() {
      return this.$route.name === this.contactUsPage;
    },
    isLoggedIn() {
      const store = useStore();
      return store.getters.isAuthenticated;
    },
    disableWarehouse() {
      return Appsettings.DisableWarehouse ?? false;
    }
  },
  methods: {
    signUp() {
      if (this.isLoggedIn) return;

      this.$router.push({ name: this.signUpPage });
    },
    faq() {
      if (this.isFaq) return;

      this.$router.push({ name: this.faqPage });
    },
    landing() {
      if (this.isHome) return;

      this.$router.push({ name: this.homePage });
    },
    contactUs() {
      if (this.isContactUs) return;
      this.$router.push({ name: this.contactUsPage });
    },
    startPackYuhBarrel() {
      this.$router.push({ name: this.orderBarrel });
    },
  },
});
</script>

<style scoped src="@/assets/css/un-auth-menu-bar.css">
</style>
